// extracted by mini-css-extract-plugin
export var copyableField = "_ow-4";
export var customerBadge = "_ow-0";
export var customerInfoTitle = "_ow-2";
export var details = "_ow-1";
export var dropdownContainer = "_ow-5";
export var dropdownImage = "_ow-6";
export var editAssigneeForm = "_ow-a";
export var editButton = "_ow-3";
export var email = "_ow-7";
export var hidden = "_ow-d";
export var input = "_ow-8";
export var saveButton = "_ow-b";
export var shopifyIcon = "_ow-c";
export var suggestionBadge = "_ow-e";
export var suggestionText = "_ow-f";
export var username = "_ow-9";